var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "client"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "href": "#",
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Client :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-group'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientid),
      expression: "clientid"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "clientid"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.clientid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getNewClientData]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Select Client")]), _vm._v(" "), _vm._l((_vm.listClientData), function(client_obj) {
    return _c('option', {
      domProps: {
        "value": client_obj.clientid
      }
    }, [_vm._v(_vm._s(client_obj.clientname))])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("AWB No :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Enter AWB NO."
    },
    model: {
      value: (_vm.awbno),
      callback: function($$v) {
        _vm.awbno = $$v
      },
      expression: "awbno"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Order Id :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-plus-o'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Enter Order Id",
      "name": "orderid",
      "id": "orderid"
    },
    model: {
      value: (_vm.orderid),
      callback: function($$v) {
        _vm.orderid = $$v
      },
      expression: "orderid"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Shipping Dt. :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-plus-o'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.shippingdate),
      callback: function($$v) {
        _vm.shippingdate = $$v
      },
      expression: "shippingdate"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }), _vm._v(" "), _c('div', {
    staticClass: "serachbtn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getShippingdocsMasterSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v(" \n                "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetSearchForm
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [(_vm.clientid == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12",
      "align": "center"
    }
  }, [_vm._v("Select Client From The Search Filter")])]) : _vm._e(), _vm._v(" "), (_vm.resultCount == 0 && _vm.clientid != '' && _vm.searchFlag == false) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12",
      "align": "center"
    }
  }, [_vm._v("Shipping List Not Found For The Selected Client")])]) : _vm._e(), _vm._v(" "), (_vm.resultCount == 0 && _vm.clientid != '' && _vm.searchFlag == true) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12",
      "align": "center"
    }
  }, [_vm._v("Shipping List Not found With Selected Filters")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listShippingDocsData), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-left ",
      attrs: {
        "scope": "row"
      }
    }, [_c('strong', [_vm._v(_vm._s(data.shippingid))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.awbno))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": data.shippingcompanyurl,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(data.shippingcompany))])]), _vm._v(" "), _c('td', [(data.shippingoutdate != null) ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(data.shippingoutdate)))]) : _vm._e()]), _vm._v(" "), _c('td', [(data.shippingdate != null) ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(data.shippingdate)))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.totalitem))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.shippingamount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.shipmentlength) + "*" + _vm._s(data.shipmentbreadth) + "*" + _vm._s(data.shipmentheight))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.shipmentvolumetricweight) + " - " + _vm._s(data.shipmentweight))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.shipmentstatus))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": "#",
        "title": "Print Invoice"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.generateInvoice(data)
        }
      }
    }, [_vm._v("Print Cust Invoice")])]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": "#",
        "title": "Print Invoice"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.generateTaxInvoice(data)
        }
      }
    }, [_vm._v("Print Tax Invoice")])])])
  })], 2)])]), _vm._v(" "), _c('paginate', {
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    on: {
      "ok": function($event) {
        _vm.invoicemodal = false
      }
    },
    model: {
      value: (_vm.invoicemodal),
      callback: function($$v) {
        _vm.invoicemodal = $$v
      },
      expression: "invoicemodal"
    }
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body"
  }, [_c('table', {
    staticClass: "table table-bordered ",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "background-color": "#e4dddd"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "src": "http://tplstage.xbees.in/tplappv2/static/img/logo_healthfolks.png"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "200px"
    }
  }, [_vm._v(" Customer acknowledgement:  ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "60%",
      "colspan": "2"
    }
  }, [_c('span', [_vm._v(" Name:  " + _vm._s(_vm.clientdata.clientname))])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_vm._v("Address:  " + _vm._s(_vm.clientdata.clientaddress) + "," + _vm._s(_vm.clientdata.clientaddress2) + "," + _vm._s(_vm.clientdata.city) + " – " + _vm._s(_vm.clientdata.pincode))]), _vm._v(" Ph :- 18002082222\n                    ")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v("Details Of Recevier (Patient): ")]), _c('br'), _vm._v(" "), _c('label', [_vm._v("Name: " + _vm._s(_vm.ordermaster.customerfirstname) + " " + _vm._s(_vm.ordermaster.customerlastname) + " ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v("Gst In: 36AALCM3440J1ZB\n\n                     ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', {
    staticClass: "col-md-12 col-lg-12 col-sm-12"
  }, [_vm._v("\n                       Address: " + _vm._s(_vm.ordermaster.custaddress1) + "," + _vm._s(_vm.ordermaster.custaddress2) + "," + _vm._s(_vm.ordermaster.custstate) + "," + _vm._s(_vm.ordermaster.custcity) + ",\n                     "), _c('br'), _c('br')])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', {
    staticClass: "col-md-12 col-lg-12 col-sm-12"
  }, [_vm._v("\n                         CIN: U72900TG2017PTC119669\n                       ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v(" DL NO: TS-RR-20-2018-38388 , TS-RR-21-2018-38388\n                     ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v("\n                      State: " + _vm._s(_vm.ordermaster.custstate)), _c('br'), _c('br'), _vm._v("\n                      State /UI Code: " + _vm._s(_vm.ordermaster.custpincode) + "\n\n                     ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v(" Order Id:\n                    ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ordermaster.poid))])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v("GST Unique Id")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v(" Serial No Of Invoice: " + _vm._s(_vm.ordermaster.invoicenumber))])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v("DOC Name")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ordermaster.doctorname))])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v(" Date Of Invoice: "), _c('span', {
    staticClass: "filter"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.ordermaster.orderdate)))])])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v("Address")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ordermaster.doctoraddress))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {}, [_c('table', {
    staticClass: "table-bordered table",
    staticStyle: {
      "position": "relative",
      "overflow": "auto",
      "font-size": "12px",
      "margin-left": "16px"
    }
  }, [_c('thead', {
    staticClass: "poform_tableheader"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "padding": "2.5px",
      "width": "10%"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Description of Goods/Services(Brand)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "2.5px",
      "width": "10%"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Manufacturer")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "2.5px",
      "width": "10%"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Strength")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "2.5px",
      "width": "10%"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Batch Number")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "2.5px",
      "width": "10%"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Expiry")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "2.5px",
      "width": "10%"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("HSN/SAC")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "2.5px",
      "width": "10%"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Qty")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "2.5px",
      "width": "10%"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("UOM")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "2.5px",
      "width": "10%"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("MRP")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "2.5px",
      "width": "10%"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Total MRP(A)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "2.5px",
      "width": "10%"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Discount(B)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "2.5px",
      "width": "10%"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Amount Payable(A-B)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "2.5px",
      "width": "10%"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Taxable Value")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("SGST")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("CGST")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("IGST")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Rate")]), _vm._v(" "), _c('th', [_vm._v("Amount")]), _vm._v(" "), _c('th', [_vm._v("Rate")]), _vm._v(" "), _c('th', [_vm._v("Amount")]), _vm._v(" "), _c('th', [_vm._v("Rate")]), _vm._v(" "), _c('th', [_vm._v("Amount")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.orderDetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "200px",
        "display": "table-cell",
        "word-break": "break-word"
      }
    }, [_vm._v(_vm._s(data.productname))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "100px",
        "display": "table-cell",
        "word-wrap": "break-word"
      }
    }, [_vm._v(_vm._s(data.brand))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "100px",
        "display": "table-cell",
        "word-wrap": "break-word"
      }
    }, [_vm._v(_vm._s(data.strength))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "100px",
        "display": "table-cell",
        "word-wrap": "break-word"
      }
    }, [_vm._v(_vm._s(data.lotcontrol))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.expirydate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.hsncode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.primaryuom))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.getScore(data.mrp)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.getScore(data.mrp * data.quantity)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.getScore(data.mrp * (data.discount / 100))))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.getScore(data.mrp - data.mrp * (data.discount / 100))))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.getScore(_vm.calcuateTaxable(data.mrp, data.quantity, data.discount, data.igst, data.cgst, data.sgst))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.sgst))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.getScore(_vm.calcuatesgstAmount(data.mrp, data.quantity, data.discount, data.sgst))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.cgst))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.getScore(_vm.calcuatecgstAmount(data.mrp, data.quantity, data.discount, data.cgst))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.igst))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.getScore(_vm.calcuateigstAmount(data.mrp, data.quantity, data.discount, data.igst))))])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qty))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.getScore(_vm.mrp)))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-bordered mytable12 "
  }, [_c('tbody', {
    staticStyle: {
      "height": "80%"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "width": "80%"
    }
  }, [_c('table', [_c('tbody', [_c('tr', {
    attrs: {
      "width": "80%"
    }
  }, [_c('td', {
    staticStyle: {
      "width": "980px"
    }
  }, [_vm._v("Delivery Charges(inclusive of taxes): ₹ " + _vm._s(_vm.getScore(_vm.shippingcharges)))])]), _vm._v(" "), _c('tr', {
    attrs: {
      "width": "80%"
    }
  }, [_c('td', {
    staticStyle: {
      "width": "980px"
    }
  }, [_vm._v("Total Invoice Value (In Figure): ₹ " + _vm._s(_vm.getScore(_vm.total)))])]), _vm._v(" "), _c('tr', {
    attrs: {
      "width": "80%"
    }
  }, [_c('td', {
    staticStyle: {
      "width": "980px"
    }
  }, [_vm._v("Total Invoice Value (In Words): " + _vm._s(_vm.number2text(_vm.total)))])]), _vm._v(" "), _c('tr', {
    attrs: {
      "width": "80%"
    }
  }, [_c('td')]), _vm._v(" "), _c('tr', {
    attrs: {
      "width": "80%"
    }
  }, [_c('td', {
    staticStyle: {
      "width": "980px"
    }
  }, [_vm._v("Net Amount Payable ₹ " + _vm._s(_vm.getScore(_vm.total)))])]), _vm._v(" "), _c('tr', {
    attrs: {
      "width": "80%"
    }
  }, [_c('td', {
    staticStyle: {
      "width": "980px"
    }
  }, [_vm._v("Amount of Tax subject to Reverse Charges: NIL")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "980px"
    }
  }, [_vm._v("Remarks")])])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "70%"
    }
  }, [_c('tbody', {
    staticStyle: {
      "height": "80%"
    }
  }), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "height": "80%"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-bordered mytable12 "
  }, [_c('tbody', {
    staticStyle: {
      "height": "80%"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('p', [_c('br'), _vm._v("\n                          Customer Acknowledgement\nI, the undersigned hereby acknowledge the delivery of my order in full as prescribed by my Doctor and sent to Health Folks for fulfilment upon my request. I hereby confirm that I\nhave checked the contents of the delivery and matched the same with the prescription and have found everything in order. I also understand that Healthfolks is a retail pharmacy\ndispensing the order, and is not responsible for the prescription or consumption of products in the prescription and any untoward incident arising out of the same. I understand that\nHealthfolks will store all my personal information securely in an encrypted format and that Healthfolks, its directors, employees, partners or affiliates will have no access to my\npersonal health information unless when necessary for order fulfilment or when specifically authorized by me. I signed up for Healthfolks service after having read and accepted all\nterms and conditions and privacy policy as laid out on www.Healthfolks.com. All medicines are prescribed after my consultation with Doctor and delivered by Healthfolks as\ndirected by me. I have been duly informed to urgently contact my Doctor if I notice any side-effects upon consumption of any of the products in the order.\nGoods sold at MRP. Goods once sold will not be taken back. Please refer to our goods return policy at www.Healthfolks.com. We value your feedback\ncustomercare@Healthfolks.com 18002082222\n\n\n                          "), _c('strong', [_vm._v("Registered Office:-")]), _vm._v(" "), _c('span', [_vm._v("MNR DATAMIGHT PVT LTD,2-23B/350, Bhagyanagar Phase-III,Near HMT Hills Colony,Opp: JNTU,KukatpallyHyderabad – 500 085.")])])])]), _vm._v(" "), _c('td', [_c('tbody', {
    staticStyle: {
      "height": "80%"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "280px"
    }
  }, [_c('span', [_vm._v("Pharmacist Signature:  ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "280px"
    }
  }, [_c('span')])]), _vm._v(" "), _c('tr', {
    attrs: {
      "width": "90%"
    }
  }, [_c('td', {
    staticStyle: {
      "width": "280px"
    }
  }, [_c('span', [_vm._v("Customer signature & Phone  ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "280px"
    }
  }, [_c('span', [_vm._v("  ")])])])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "height": "80%"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "280px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', [_vm._v("RP Number  ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "280px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', [_vm._v("Date  ")])])])])])])])])])])])])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    on: {
      "ok": function($event) {
        _vm.invoicemodal = false
      }
    },
    model: {
      value: (_vm.invoicemodal),
      callback: function($$v) {
        _vm.invoicemodal = $$v
      },
      expression: "invoicemodal"
    }
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "taxInvoice_Content"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body"
  }, [_c('table', {
    staticClass: "table table-bordered ",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "background-color": "#e4dddd"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "src": "http://tplstage.xbees.in/tplappv2/static/img/logo_healthfolks.png"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "200px"
    }
  }, [_vm._v(" Tax Invoice:  ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "60%",
      "colspan": "2"
    }
  }, [_c('span', [_vm._v(" Name:  " + _vm._s(_vm.clientdata.clientname))])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_vm._v("Address:  " + _vm._s(_vm.clientdata.clientaddress) + "," + _vm._s(_vm.clientdata.clientaddress2) + "," + _vm._s(_vm.clientdata.city) + " – " + _vm._s(_vm.clientdata.pincode))]), _vm._v(" Ph :- 18002082222\n                    ")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v("Details Of Recevier (Patient): ")]), _c('br'), _vm._v(" "), _c('label', [_vm._v("Name: " + _vm._s(_vm.ordermaster.customerfirstname) + " " + _vm._s(_vm.ordermaster.customerlastname) + " ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v("Gst In: 36AALCM3440J1ZB\n\n                     ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', {
    staticClass: "col-md-12 col-lg-12 col-sm-12"
  }, [_vm._v("\n                       Address: " + _vm._s(_vm.ordermaster.custaddress1) + "," + _vm._s(_vm.ordermaster.custaddress2) + "," + _vm._s(_vm.ordermaster.custstate) + "," + _vm._s(_vm.ordermaster.custcity) + ",\n                     "), _c('br'), _c('br')])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', {
    staticClass: "col-md-12 col-lg-12 col-sm-12"
  }, [_vm._v("\n                         CIN: U72900TG2017PTC119669\n                       ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v(" DL NO: TS-RR-20-2018-38388 , TS-RR-21-2018-38388\n                     ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v("\n                      State: " + _vm._s(_vm.ordermaster.custstate)), _c('br'), _c('br'), _vm._v("\n                      State /UI Code: " + _vm._s(_vm.ordermaster.custpincode) + "\n\n                     ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v(" Order Id:\n                    ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ordermaster.poid))])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v("GST Unique Id")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v(" Serial No Of Invoice: " + _vm._s(_vm.ordermaster.invoicenumber))])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v("DOC Name")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ordermaster.doctorname))])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v(" Date Of Invoice: "), _c('span', {
    staticClass: "filter"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.ordermaster.orderdate)))])])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v("Address")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ordermaster.doctoraddress))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {}, [_c('table', {
    staticClass: "table-bordered table",
    staticStyle: {
      "position": "relative",
      "overflow": "auto",
      "font-size": "12px",
      "margin-left": "16px"
    }
  }, [_c('thead', {
    staticClass: "poform_tableheader"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "padding": "2.5px",
      "width": "10%"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Description of Goods/Services(Brand)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "2.5px",
      "width": "10%"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Manufacturer")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "2.5px",
      "width": "10%"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Strength")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "2.5px",
      "width": "10%"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Batch Number")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "2.5px",
      "width": "10%"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Expiry")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "2.5px",
      "width": "10%"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("HSN/SAC")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "2.5px",
      "width": "10%"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Qty")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "2.5px",
      "width": "10%"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("UOM")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "2.5px",
      "width": "10%"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("MRP")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "2.5px",
      "width": "10%"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Total MRP(A)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "2.5px",
      "width": "10%"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Discount(B)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "2.5px",
      "width": "10%"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Amount Payable(A-B)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "2.5px",
      "width": "10%"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Taxable Value")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("SGST")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("CGST")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("IGST")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Rate")]), _vm._v(" "), _c('th', [_vm._v("Amount")]), _vm._v(" "), _c('th', [_vm._v("Rate")]), _vm._v(" "), _c('th', [_vm._v("Amount")]), _vm._v(" "), _c('th', [_vm._v("Rate")]), _vm._v(" "), _c('th', [_vm._v("Amount")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.orderDetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "200px",
        "display": "table-cell",
        "word-break": "break-word"
      }
    }, [_vm._v(_vm._s(data.productname))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "100px",
        "display": "table-cell",
        "word-wrap": "break-word"
      }
    }, [_vm._v(_vm._s(data.brand))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "100px",
        "display": "table-cell",
        "word-wrap": "break-word"
      }
    }, [_vm._v(_vm._s(data.strength))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "100px",
        "display": "table-cell",
        "word-wrap": "break-word"
      }
    }, [_vm._v(_vm._s(data.lotcontrol))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.expirydate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.hsncode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.primaryuom))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.getScore(data.mrp)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.getScore(data.mrp * data.quantity)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.getScore(data.mrp * (data.discount / 100))))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.getScore(data.mrp - data.mrp * (data.discount / 100))))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.getScore(_vm.calcuateTaxable(data.mrp, data.quantity, data.discount, data.igst, data.cgst, data.sgst))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.sgst))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.getScore(_vm.calcuatesgstAmount(data.mrp, data.quantity, data.discount, data.sgst))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.cgst))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.getScore(_vm.calcuatecgstAmount(data.mrp, data.quantity, data.discount, data.cgst))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.igst))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.getScore(_vm.calcuateigstAmount(data.mrp, data.quantity, data.discount, data.igst))))])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.qty))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.getScore(_vm.mrp)))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-bordered mytable12 "
  }, [_c('tbody', {
    staticStyle: {
      "height": "80%"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "width": "80%"
    }
  }, [_c('table', [_c('tbody', [_c('tr', {
    attrs: {
      "width": "80%"
    }
  }, [_c('td', {
    staticStyle: {
      "width": "980px"
    }
  }, [_vm._v("Delivery Charges(inclusive of taxes): ₹ " + _vm._s(_vm.getScore(_vm.shippingcharges)))])]), _vm._v(" "), _c('tr', {
    attrs: {
      "width": "80%"
    }
  }, [_c('td', {
    staticStyle: {
      "width": "980px"
    }
  }, [_vm._v("Total Invoice Value (In Figure): ₹ " + _vm._s(_vm.getScore(_vm.total)))])]), _vm._v(" "), _c('tr', {
    attrs: {
      "width": "80%"
    }
  }, [_c('td', {
    staticStyle: {
      "width": "980px"
    }
  }, [_vm._v("Total Invoice Value (In Words): " + _vm._s(_vm.number2text(_vm.total)))])]), _vm._v(" "), _c('tr', {
    attrs: {
      "width": "80%"
    }
  }, [_c('td')]), _vm._v(" "), _c('tr', {
    attrs: {
      "width": "80%"
    }
  }, [_c('td', {
    staticStyle: {
      "width": "980px"
    }
  }, [_vm._v("Net Amount Payable ₹ " + _vm._s(_vm.getScore(_vm.total)))])]), _vm._v(" "), _c('tr', {
    attrs: {
      "width": "80%"
    }
  }, [_c('td', {
    staticStyle: {
      "width": "980px"
    }
  }, [_vm._v("Amount of Tax subject to Reverse Charges: NIL")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "980px"
    }
  }, [_vm._v("Remarks")])])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "70%"
    }
  }, [_c('tbody', {
    staticStyle: {
      "height": "80%"
    }
  }), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "height": "80%"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-bordered mytable12 "
  }, [_c('tbody', {
    staticStyle: {
      "height": "80%"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('p', [_c('br'), _vm._v("\n                          Customer Acknowledgement\nI, the undersigned hereby acknowledge the delivery of my order in full as prescribed by my Doctor and sent to Health Folks for fulfilment upon my request. I hereby confirm that I\nhave checked the contents of the delivery and matched the same with the prescription and have found everything in order. I also understand that Healthfolks is a retail pharmacy\ndispensing the order, and is not responsible for the prescription or consumption of products in the prescription and any untoward incident arising out of the same. I understand that\nHealthfolks will store all my personal information securely in an encrypted format and that Healthfolks, its directors, employees, partners or affiliates will have no access to my\npersonal health information unless when necessary for order fulfilment or when specifically authorized by me. I signed up for Healthfolks service after having read and accepted all\nterms and conditions and privacy policy as laid out on www.Healthfolks.com. All medicines are prescribed after my consultation with Doctor and delivered by Healthfolks as\ndirected by me. I have been duly informed to urgently contact my Doctor if I notice any side-effects upon consumption of any of the products in the order.\nGoods sold at MRP. Goods once sold will not be taken back. Please refer to our goods return policy at www.Healthfolks.com. We value your feedback\ncustomercare@Healthfolks.com 18002082222\n\n\n                          "), _c('strong', [_vm._v("Registered Office:-")]), _vm._v(" "), _c('span', [_vm._v("MNR DATAMIGHT PVT LTD,2-23B/350, Bhagyanagar Phase-III,Near HMT Hills Colony,Opp: JNTU,KukatpallyHyderabad – 500 085.")])])])]), _vm._v(" "), _c('td', [_c('tbody', {
    staticStyle: {
      "height": "80%"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "280px"
    }
  }, [_c('span', [_vm._v("Pharmacist Signature:  ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "280px"
    }
  }, [_c('span')])]), _vm._v(" "), _c('tr', {
    attrs: {
      "width": "90%"
    }
  }, [_c('td', {
    staticStyle: {
      "width": "280px"
    }
  }, [_c('span', [_vm._v("Name Of Pharmacist  ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "280px"
    }
  }, [_c('span', [_vm._v("  ")])])])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "height": "80%"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "280px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', [_vm._v("RP Number  ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "280px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', [_vm._v("Date  ")])])])])])])])])])])])])], 1)])], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Shipping List")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "tableheader"
  }, [_c('b', [_vm._v("Shipping Id")])]), _vm._v(" "), _c('th', {
    staticClass: "tableheader"
  }, [_c('b', [_vm._v("Ref No.")])]), _vm._v(" "), _c('th', {
    staticClass: "tableheader"
  }, [_c('b', [_vm._v("Shipping Company & Link")])]), _vm._v(" "), _c('th', {
    staticClass: "tableheader"
  }, [_c('b', [_vm._v(" Outscan Date")])]), _vm._v(" "), _c('th', {
    staticClass: "tableheader"
  }, [_c('b', [_vm._v("Shippin Date")])]), _vm._v(" "), _c('th', {
    staticClass: "tableheader"
  }, [_vm._v("Total Item ")]), _vm._v(" "), _c('th', {
    staticClass: "tableheader"
  }, [_c('b', [_vm._v(" Amount")])]), _vm._v(" "), _c('th', {
    staticClass: "tableheader"
  }, [_c('b', [_vm._v("L*B*H")])]), _vm._v(" "), _c('th', {
    staticClass: "tableheader"
  }, [_c('b', [_vm._v("VW - w")])]), _vm._v(" "), _c('th', {
    staticClass: "tableheader"
  }, [_c('b', [_vm._v("Shipment Status")])]), _vm._v(" "), _c('th', {
    staticClass: "tableheader"
  }, [_c('b', [_vm._v("Print Cust. Invoice")])]), _vm._v(" "), _c('th', {
    staticClass: "tableheader"
  }, [_c('b', [_vm._v("Print Tax Invoice")])])])])
}]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c681d5f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c681d5f0","hasScoped":true}!./src/views/components/shippingdocs/shippingdocs.component.html
// module id = 1373
// module chunks = 0